import { render, staticRenderFns } from "./ApiDashboardWidgetItem.vue?vue&type=template&id=bffdb06a&scoped=true"
import script from "./ApiDashboardWidgetItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApiDashboardWidgetItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ApiDashboardWidgetItem.vue?vue&type=style&index=0&id=bffdb06a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffdb06a",
  null
  
)

export default component.exports